import React, { useEffect, useState, useContext } from 'react';

import Layout from '../components/Layout';

import { getCookie } from '../helpers/cookies';
import { getData, getTodayOnairData, todayOnairFormat } from '../constants/api_index';
import { POPUP_NAME } from '../constants/index';
import { NavBar, Body } from '../styles/homeStyles';
import { LayoutContext } from '../context/layoutContext';

import Banner from '../components/banner/Banner';
import OnAir from '../components/onAir/OnAir';
import MainVodList from './vod/MainVodList';
import RecVodList from './vod/RecVodList';
import ContentsList from './vod/ContentsList';
import MainPanel from './common/MainPanel';
import IconGroup from './IconGroup';

import MainPopup from '../components/MainPopup';
import MainUrlPopup from '../components/MainUrlPopup';

import PromotionBanner from './common/PromotionBanner';

import { connect } from 'react-redux';

const APILIST = ['youtube', 'episode/free', 'product', 'template', ''];

const Home = ({ userInfo }) => {
  const { matchese } = useContext(LayoutContext);

  const [onAirList, setOnAirList] = useState([]);

  const [freeVodList, setFreeVodList] = useState([]);
  const [youTubeVodList, setYouTubeVodList] = useState([]);
  const [shoppingList, setShoppingList] = useState([]);
  const [playLogList, setPlayLogList] = useState([]);

  const [templateList, setTemplateList] = useState([]);

  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    getMainApiList(userInfo);
  }, [userInfo]);

  useEffect(() => {
    if (!getCookie(POPUP_NAME)) {
      setPopupOpen(true);
    }
  }, []);

  useEffect(() => {
    if (onAirList.length > 0) {
      // onAir Time Update
      let update = setInterval(() => {
        setOnAirList(todayOnairFormat(onAirList));
      }, [60000]);

      return () => clearInterval(update);
    }
  }, [onAirList]);

  const getMainApiList = info => {
    if (info) APILIST[4] = `playLog/my?userId=${info?.id}`;

    Promise.all([
      getData(APILIST[0]),
      getData(APILIST[1]),
      getData(APILIST[2]),
      getData(APILIST[3]),
      getData(APILIST[4]),
      getTodayOnairData(),
    ]).then(res => {
      res.map((api, idx) => {
        if (api?.value) {
          api?.value.sort((a, b) => {
            return Number(a?.updatedAt) < Number(b?.updatedAt) ? 1 : -1;
          });
        }

        if (idx === 0 && api) setYouTubeVodList(api?.value ? [...api?.value] : []);
        if (idx === 1 && api) setFreeVodList(api?.value ? [...api?.value] : []);
        if (idx === 2 && api) setShoppingList(api?.value ? [...api?.value] : []);
        if (idx === 3 && api) setTemplateList(api?.value ? [...api?.value] : []);
        if (idx === 4 && api) setPlayLogList(api?.value ? [...api?.value?.slice(0, 12)] : []);
        if (idx === 5 && api) setOnAirList(todayOnairFormat(api));
      });
    });
  };

  return (
    <Layout headerHide={true} home={true}>
      {/* home Header는 Banner 안에 있음. */}
      <Banner />

      {/* 실시간 */}
      <OnAir data={onAirList} prevShow={matchese} nextShow={matchese} />

      {/* 오늘의 본방송 & 주간 BEST & 최신 VOD */}
      <MainVodList />

      <PromotionBanner category='중앙' />

      {/* 절찬 방영중 ~ */}
      <RecVodList />

      <Body Ptb={true}>
        <ContentsList
          list={playLogList}
          title={'나의 시청리스트'}
          type='vod-record'
          detail='vod-record'
          optionType='fliking'
          contetentHeight={matchese ? '130px' : '159px'}
          playBtn={true}
          animation='select'
          wrap={matchese}
          showCnt={matchese ? 4 : 4}
          hide={!userInfo || !playLogList.length}
        />
        <ContentsList
          list={freeVodList}
          title={'무료 프로그램'}
          type='sub-vod'
          detail='vod-detail'
          optionType='fliking'
          contetentHeight={matchese ? '130px' : '159px'}
          playBtn={true}
          wrap={matchese}
          showCnt={matchese ? 4 : 4}
          animation='move'
          hide={!freeVodList.length}
        />
        <ContentsList
          list={youTubeVodList}
          title={'유튜브 프로그램'}
          type='sub-vod'
          detail='youtube'
          optionType='fliking'
          contetentHeight={matchese ? '125px' : '130px'}
          playBtn={true}
          showCnt={matchese ? 2 : 5}
          animation='move'
        />
      </Body>

      <PromotionBanner category='쇼핑몰' Pb={true} />

      <NavBar>
        <ContentsList
          list={shoppingList}
          title={'FTV 쇼핑몰'}
          type='shopping'
          detail='shopping'
          optionType='fliking'
          contetentHeight={matchese ? '170px' : '220px'}
          wrap={matchese}
          showCnt={matchese ? 2 : 5}
        />
      </NavBar>

      {/* 메인코너 관리 영역 */}
      {templateList.length > 0 &&
        templateList.map((temp, idx) => (
          <Body Pt={idx === 0} key={`template_${temp.title}_${idx}`}>
            <ContentsList
              list={temp.contents}
              title={temp.title}
              type={'sub-vod'}
              detail={temp.contentsType === 'program' ? 'sub-vod' : 'vod-detail'}
              contetentHeight={matchese ? '130px' : '159px'}
              optionType='fliking'
              wrap={matchese}
              showCnt={matchese ? 4 : 5}
              animation='move'
            />
          </Body>
        ))}

      {/* 조황정보 / 낚시대회 일정 */}
      <MainPanel />

      <PromotionBanner category='메인하단' Pb={true} />

      <IconGroup />

      {/* 팝업 */}
      {/* <MainPopup open={popupOpen} close={() => setPopupOpen(false)} /> */}
      <MainUrlPopup />
    </Layout>
  );
};

const mapStateToProps = state => {
  return {
    userInfo: state.userData.user,
  };
};

export default connect(mapStateToProps)(Home);
